/**
 * Returns the browser language predefined by the user
 */
export const getBrowserLanguage = () => navigator.language.toLocaleLowerCase();

export const getDocument = () => document;
